export enum BrotherAttributionModalType {
  createNewFamilyConnection = 0,
  editFamilyConnection = 1,
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brother-attribution-models/brother-attribution-modal-type.ts